module.exports = __webpack_public_path__ + "img/add_icon.a57b295d.svg";